import { render, staticRenderFns } from "./shareWnq.vue?vue&type=template&id=2a2a7e46&scoped=true"
import script from "./shareWnq.vue?vue&type=script&lang=js"
export * from "./shareWnq.vue?vue&type=script&lang=js"
import style0 from "./shareWnq.vue?vue&type=style&index=0&id=2a2a7e46&prod&lang=css"
import style1 from "./shareWnq.vue?vue&type=style&index=1&id=2a2a7e46&prod&lang=scss&scoped=true"
import style2 from "./shareWnq.vue?vue&type=style&index=2&id=2a2a7e46&prod&lang=scss&scoped=true"
import style3 from "./shareWnq.vue?vue&type=style&index=3&id=2a2a7e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a7e46",
  null
  
)

export default component.exports